import List from './List';
import Details from './Details';

const Tasks = {
  List,
  Details
}

export default Tasks;